import { Element, useNode } from "@craftjs/core";
import { rem } from "polished";
import * as React from "react";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import Action, {
  ActionComponentStyle,
  ACTIONS,
} from "@/components/editor/primitives/legacy/action/action-component";
import RichText from "@/components/editor/primitives/rich-text";
import Text from "@/components/editor/primitives/text/text-component";
import {
  BlockBackgroundColorWrapper,
  BlockMaxWidthWrapper,
  BlockPaddingWrapper,
} from "@/components/editor/shared/block-wrapper";
import useRichTextCompatible from "@/hooks/use-rich-text-compatible";

import {
  Content,
  CTAButtonWrapper,
  TextWrapper,
} from "./divider-component-styles";

type DividerProps = {
  title: string;
  paragraph: string;
};

export default function Divider(props: DividerProps) {
  const {
    connectors: { connect },
    nodeId,
  } = useNode((node) => ({
    nodeId: node.id,
  }));

  const ctaButtonStyle = React.useMemo<ActionComponentStyle>(
    () => ({
      padding: [rem(12), `${rem(12)} ${rem(52)}`, `${rem(12)} ${rem(52)}`],
    }),
    []
  );

  const isRichTextCompatible = useRichTextCompatible(nodeId, ["divider-text"]);

  return (
    <BlockBackgroundColorWrapper ref={connect} id={nodeId}>
      <BlockPaddingWrapper>
        <BlockMaxWidthWrapper>
          <Content>
            <Element
              id="divider-title"
              is={Text}
              text={props.title}
              element="h2"
              pattern="headingTwo"
            />
            <TextWrapper>
              {isRichTextCompatible ? (
                <Element
                  id="divider-text"
                  is={RichText}
                  text={`<p style='text-align:center;'>${props.paragraph}</p>`}
                />
              ) : (
                <Element
                  id="divider-text"
                  is={Text}
                  text={props.paragraph}
                  element="p"
                  pattern="paragraph"
                />
              )}
            </TextWrapper>
          </Content>
          <CTAButtonWrapper>
            <Element
              id="divider-cta-button"
              is={Action}
              element="button"
              text="Register"
              style={ctaButtonStyle}
              action={ACTIONS.registrationPage}
              actions={[ACTIONS.registrationPage, ACTIONS.externalLink]}
              showOptions
            />
          </CTAButtonWrapper>
        </BlockMaxWidthWrapper>
      </BlockPaddingWrapper>
    </BlockBackgroundColorWrapper>
  );
}

Divider.craft = {
  custom: {
    displayName: "Divider",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
  },
  rules: {
    canMoveIn: () => false,
  },
};
